import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Hotaltravelsdeskcabserviceinpune() {



  const cardData =
  {
    keyword: ' Hotel Travel Desk Cab Service in Pune ',
    heading: 'Pune Corporate Cars India Private Limited: Hotel Travel Desk Cab Service in Pune ',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Hotel Travel Desk Cab Service in Pune, offering seamless transportation support for business travelers, corporate guests, tourists, and VIP visitors staying in leading hotels across the city. Our fleet of well-maintained sedans, SUVs, MUVs, and premium cars ensures safe, comfortable, and timely travel for airport transfers, corporate meetings, city tours, event travel, and inter-city trips. We work closely with hotel travel desks to provide 24×7 availability, trained chauffeurs, GPS-enabled vehicles, flexible billing options, and customized travel arrangements based on guest requirements. With high service standards, punctuality, and a commitment to comfort, Pune Corporate Cars India Private Limited ensures a smooth, hassle-free, and premium transportation experience for hotel guests in Pune.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

"topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],


"services": [
  {
    "name": "Hotel Taxi Service Pune",
    "description": "Hotel Taxi Service Pune offers reliable and comfortable cab services for hotel guests, ensuring smooth transfers to and from hotels, airports, railway stations, and local attractions with professional drivers and GPS tracking."
  },
  {
    "name": "Corporate Hotel Cab Pune",
    "description": "Corporate Hotel Cab Pune provides premium transportation solutions for business travelers staying at hotels. Services include timely pickups, corporate-friendly routes, and professional chauffeurs for seamless travel."
  },
  {
    "name": "Travel Desk Cab Provider Pune",
    "description": "Travel Desk Cab Provider Pune caters to hotel travel desks by offering managed cab services for guests, including airport transfers, city sightseeing, and business trips, ensuring punctuality, comfort, and convenience."
  },
  {
    "name": "Hotel Airport Transfer Pune",
    "description": "Hotel Airport Transfer Pune ensures timely and safe transfers between hotels and airports for guests. Services include real-time tracking, trained chauffeurs, and a choice of sedans and SUVs to suit individual or group travel."
  },
  {
    "name": "Guest Transportation Pune",
    "description": "Guest Transportation Pune delivers end-to-end transport solutions for hotel visitors, including city tours, airport transfers, and inter-hotel commutes, emphasizing safety, punctuality, and comfort."
  },
  {
    "name": "Luxury Hotel Cab Pune",
    "description": "Luxury Hotel Cab Pune provides high-end vehicles such as premium sedans and SUVs for guests seeking comfort and style. Professional chauffeurs and personalized service ensure an exclusive travel experience."
  },
  {
    "name": "Chauffeur Cab for Hotels Pune",
    "description": "Chauffeur Cab for Hotels Pune offers professional chauffeur-driven services for hotel guests, including airport transfers, city travel, and corporate trips, ensuring a high standard of service and punctuality."
  },
  {
    "name": "5-Star Hotel Cab Pune",
    "description": "5-Star Hotel Cab Pune specializes in premium transportation for luxury hotel guests, offering well-maintained vehicles, expert drivers, and bespoke travel solutions for business and leisure travelers."
  },
  {
    "name": "Business Hotel Cab Pune",
    "description": "Business Hotel Cab Pune caters to corporate guests with reliable, comfortable, and timely transport for meetings, airport pickups, and hotel transfers, ensuring smooth business travel logistics."
  },
  {
    "name": "Hotel Pickup Drop Pune",
    "description": "Hotel Pickup Drop Pune provides scheduled pick-up and drop services for hotel guests, ensuring convenience, punctuality, and safety for all local or intercity travel requirements."
  },
  {
    "name": "Premium Hotel Transfer Pune",
    "description": "Premium Hotel Transfer Pune offers luxury and executive transport solutions for guests, including airport transfers, corporate travel, and sightseeing, with well-maintained vehicles and professional chauffeurs."
  },
  {
    "name": "Executive Travel for Hotels Pune",
    "description": "Executive Travel for Hotels Pune focuses on business travelers, providing efficient, reliable, and comfortable transport between hotels, offices, and airports with professional chauffeurs and GPS tracking."
  },
  {
    "name": "Hotel Cab Booking Pune",
    "description": "Hotel Cab Booking Pune provides easy and convenient online booking for hotel cab services, allowing guests to schedule pickups, choose vehicle types, and track rides for a seamless travel experience."
  },
  {
    "name": "Hotel Tourism Cab Pune",
    "description": "Hotel Tourism Cab Pune delivers curated travel experiences for guests, offering sightseeing tours, local attractions, and leisure trips with guided chauffeurs and safe, comfortable vehicles."
  },
  {
    "name": "Hotel Fleet Service Pune",
    "description": "Hotel Fleet Service Pune provides managed fleet solutions for hotels, including sedans, SUVs, and shuttle vans, ensuring high service standards, professional drivers, and reliable transport for all guests."
  }
],

"tableData": [
  ["Hotel Taxi Service Pune", "Corporate Hotel Cab Pune"],
  ["Travel Desk Cab Provider Pune", "Hotel Airport Transfer Pune"],
  ["Guest Transportation Pune", "Luxury Hotel Cab Pune"],
  ["Chauffeur Cab for Hotels Pune", "5-Star Hotel Cab Pune"],
  ["Business Hotel Cab Pune", "Hotel Pickup Drop Pune"],
  ["Premium Hotel Transfer Pune", "Executive Travel for Hotels Pune"],
  ["Hotel Cab Booking Pune", "Hotel Tourism Cab Pune"],
  ["Hotel Fleet Service Pune", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Hotel Travel Desk Cab Service in Pune",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable hotel travel desk cab services in Pune, ensuring seamless transportation for hotel guests, business travelers, and corporate visitors."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We offer punctual pickups and drop-offs from hotels to airports, offices, industrial zones, and tourist spots, ensuring guests reach their destinations on time."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs provide safe, courteous, and disciplined travel, delivering a secure and comfortable journey for hotel guests and corporate travelers."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained for reliable and comfortable travel for hotel guests in Pune."
  },
  {
    "WhyChooseheading": "Customized Travel Solutions",
    "WhyChoosedescription": "We offer flexible and tailored travel plans to meet the specific transportation needs of hotel guests, corporate travelers, and VIP clients."
  },
  {
    "WhyChooseheading": "24/7 Travel Support",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for bookings, emergencies, and route adjustments, ensuring uninterrupted travel for hotel guests."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are sanitized regularly and equipped with modern safety features, offering secure and hygienic rides for hotel guests and corporate travelers."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Travel management is streamlined through our easy booking system and reliable coordination, making hotel guest transport hassle-free."
  }
]




















  }

  
const faqData = [
  {
    question: 'Do you provide hotel travel desk cab services in Pune?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers professional and reliable cab services for hotel travel desks, assisting guests with airport transfers, local sightseeing, and corporate travel needs.',
  },
  {
    question: 'What types of services are available for hotel guests in Pune?',
    answer: 'We provide airport pickups and drops, city transfers, outstation travel, corporate bookings, and customized travel solutions for hotel guests.',
  },
  {
    question: 'Can hotels book cabs for multiple guests at once?',
    answer: 'Absolutely. Hotels can book multiple cabs simultaneously for guest groups, corporate events, or conferences.',
  },
  {
    question: 'How can hotels book travel desk cab services in Pune?',
    answer: 'Bookings can be made via our website, mobile app, or by contacting our dedicated 24×7 corporate support team.',
  },
  {
    question: 'Which vehicles are available for hotel travel desk cab services?',
    answer: 'We offer hatchbacks, sedans, SUVs, luxury cars, Innova Crysta, tempo travellers, and electric vehicles based on guest requirements.',
  },
  {
    question: 'Do you provide long-term contracts for hotel cab services?',
    answer: 'Yes, we provide monthly, quarterly, and annual cab contracts tailored to hotel requirements with transparent pricing.',
  },
  {
    question: 'Are the vehicles GPS-enabled and safe for guests?',
    answer: 'All vehicles are GPS-enabled, regularly sanitized, and driven by trained and verified chauffeurs to ensure guest safety and comfort.',
  },
  {
    question: 'Do you provide cab services for corporate events or conferences at hotels?',
    answer: 'Absolutely. We provide reliable transport solutions for corporate events, conferences, and VIP guest transfers.',
  },
  {
    question: 'What payment options are available for hotel travel desk cab services?',
    answer: 'We accept UPI, bank transfers, credit/debit cards, digital wallets, and provide consolidated monthly invoicing for hotels.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Nikhil Kulkarni',
    feedback: 'Reliable hotel travel desk cab service in Pune. Guests consistently praise the punctuality, comfort, and professionalism of the drivers.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Ananya Desai',
    feedback: 'Excellent service for hotel guests. Smooth rides, timely pickups, and hassle-free bookings make it a perfect travel partner for hotels.',
    rating: 5,
  },
];


















































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Hotel Travel Desk Cab Service in Pune",
  "image": "https://www.punecorporatecars.com/assets/images/hotel-cab-service-pune.jpg", // replace with actual image URL
  "description":
    "Pune Corporate Cars India Private Limited offers premium Hotel Travel Desk Cab Services in Pune, including hotel airport transfers, guest transportation, luxury chauffeur-driven cabs for hotels, 5-star hotel cab services, business hotel cabs, hotel pickup and drop services, executive travel for hotels, hotel fleet services, and seamless booking for hotel transportation needs.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/hotel-travel-desk-cab-service-pune"
  }
};






  return (
    <div>
<Helmet>
  <title>Hotel Travel Desk Cab Service in Pune | Luxury, Airport & Hotel Transfers</title>

  <meta
    name="description"
    content="Hotel Travel Desk Cab Service in Pune offering luxury taxi service, airport transfers, guest transportation, chauffeur cabs for hotels, 5-star hotel pickups, business hotel transport, and seamless travel desk services for hotels in Pune."
  />

  <meta
    name="keywords"
    content="Hotel Taxi Service Pune, Corporate Hotel Cab Pune, Travel Desk Cab Provider Pune, Hotel Airport Transfer Pune, Guest Transportation Pune, Luxury Hotel Cab Pune, Chauffeur Cab for Hotels Pune, 5-Star Hotel Cab Pune, Business Hotel Cab Pune, Hotel Pickup Drop Pune, Premium Hotel Transfer Pune, Executive Travel for Hotels Pune, Hotel Cab Booking Pune, Hotel Tourism Cab Pune, Hotel Fleet Service Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/105.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Hotaltravelsdeskcabserviceinpune;